<router-outlet></router-outlet>
<!-- <div>hello app</div> -->

<p-toast key="info" [style]="{ marginTop: '80px' }"></p-toast>
<p-toast
  key="info-large"
  position="center"
  styleClass="info-large-toast"
  [baseZIndex]="10000"
></p-toast>
<p-toast key="modal" position="center" [baseZIndex]="50000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-center">
        <i
          *ngIf="message.severity === 'info'"
          class="fa fa-smile-o mt-2"
          style="font-size: 3em"
        ></i>
        <i
          *ngIf="message.severity === 'warn'"
          class="pi pi-exclamation-triangle"
          style="font-size: 3em"
        ></i>
        <h3>{{ message.summary }}</h3>
        <p *ngIf="message.detail">{{ message.detail }}</p>
        <div
          *ngIf="message.data.detailInHTML"
          [innerHTML]="message.data.detailInHTML"
        ></div>
      </div>
      <div class="p-text-center">
        <div *ngIf="message.data.onConfirm" class="m-2">
          <button
            type="button"
            pButton
            (click)="message.data.onConfirm()"
            [label]="message.data.confirmBtnLabel || 'Yes'"
            class="p-button-warning"
          ></button>
        </div>
        <!-- <div *ngIf="message.data.onReject" class="m-2">
                    <button type="button" pButton (click)="message.data.onReject()" [label]="message.data.rejectBtnLabel || 'No'" class="p-button-danger"></button>
                </div> -->
      </div>
    </div>
  </ng-template>
</p-toast>

<p-confirmDialog
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text"
>
</p-confirmDialog>
